// LeaderboardCategoryUsers.js
import { connect } from 'react-redux';

import LeaderboardCategoryUsers from '../component/LeaderboardCategoryUsers.jsx';
import fetchLeaderboardUsers from '../action/fetchLeaderboardUsers.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';
import {
  list as listSelectPath,
  networking as networkingSelectPath,
} from '../resource/selectPath.js';

const mapStateToProps = (state, { category, range, region }) => {
  const selectPath = listSelectPath.leaderboard({ region, category, range });
  const userIds = getListData(state, selectPath, 'itemIds');
  const nextPage = getListData(state, selectPath, 'nextPage');
  const isNextPageFetching = !!getNetworkingData(
    state,
    networkingSelectPath.leaderboard({
      region,
      category,
      range,
      page: nextPage,
    }),
    'isFetching'
  );
  const isFetched = getNetworkingData(
    state,
    networkingSelectPath.leaderboard({
      region,
      category,
      range,
      page: 1,
    }),
    'isFetched'
  );
  const isAuthed = getMeData(state, 'id') != null;

  return {
    userIds,
    nextPage,
    isNextPageFetching,
    isFetched,
    isAuthed,
  };
};

const mapDispatchToProps = (dispatch, { category, range, region }) => {
  return {
    fetchLeaderboardUsers: ({ page }) =>
      dispatch(fetchLeaderboardUsers({ category, range, page, region })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeaderboardCategoryUsers);
